
import { Component, Prop, Vue } from "vue-property-decorator";
import MatchInterface from "@/libs/model/MatchInterface";

@Component({})
export default class TeamsScore extends Vue
{
  name: 'TeamsComponent';
  @Prop() matchdata: MatchInterface;
  @Prop() type: string;
  
  get teamScore() {
     if(this.matchdata.liveData && this.matchdata.liveData.matchDetails && this.matchdata.liveData.matchDetails.matchStatus === "Abandoned" && this.type == "first"){
      return "Abandoned";
    }

     if(this.matchdata.liveData && this.matchdata.liveData.matchDetails && this.matchdata.liveData.matchDetails.matchStatus === "Postponed"){
      if(this.matchdata.matchInfo && (!this.matchdata.matchInfo.date || this.matchdata.matchInfo.date === "")) {
        if(this.type == "first") {
          return "Postponed";
        }
        if(this.type == "second") {
          return "Time TBD";
        }

      }
      if(this.matchdata.matchInfo && this.matchdata.matchInfo.date && this.matchdata.matchInfo.date !== "" && this.type == "first") {
        return "Rescheduled";
      }  
    }

    if(typeof(this.matchdata.liveData) !== 'undefined' && this.type == "first"){
     if(typeof(this.matchdata.liveData.matchDetails.scores)  !== 'undefined'){
      if(typeof(this.matchdata.liveData.matchDetails.scores.pen) != "undefined" && this.matchdata.liveData.matchDetails.scores.pen !== null) {
        return this.matchdata.liveData.matchDetails.scores.et.home + " (" + this.matchdata.liveData.matchDetails.scores.pen.home + ")";
      }
      return this.matchdata.liveData.matchDetails.scores.ft.home;
     }
    } else if(typeof(this.matchdata.liveData) !== 'undefined' && this.type == "second"){
      if(typeof(this.matchdata.liveData.matchDetails.scores)  !== 'undefined'){
        if(typeof(this.matchdata.liveData.matchDetails.scores.pen) != "undefined" && this.matchdata.liveData.matchDetails.scores.pen !== null) {
          return this.matchdata.liveData.matchDetails.scores.et.away + " (" + this.matchdata.liveData.matchDetails.scores.pen.away + ")";
        }
        return this.matchdata.liveData.matchDetails.scores.ft.away;
      }
    }
    return "";
  }

  get scoreClass() {
    if(this.matchdata.liveData && this.matchdata.liveData.matchDetails && this.matchdata.liveData.matchDetails.matchStatus === "Abandoned" && this.type == "first"){
      return "score-abandoned";
    }

    if(this.matchdata.liveData && this.matchdata.liveData.matchDetails && this.matchdata.liveData.matchDetails.matchStatus === "Postponed"){
      if(this.matchdata.matchInfo && (!this.matchdata.matchInfo.date || this.matchdata.matchInfo.date === "")) {
        if(this.type == "first") {
          return "score-postponed";
        }
        if(this.type == "second") {
          return "score-timetbd";
        }

      }
      if(this.matchdata.matchInfo && this.matchdata.matchInfo.date && this.matchdata.matchInfo.date !== "" && this.type == "first") {
        return "score-rescheduled";
      }  
    }

    // Add Winning/Losing Team Class
    if(this.matchdata.liveData.matchDetails.matchStatus === "Played") {
      if(typeof(this.matchdata.liveData) !== 'undefined' && this.type == "first"){
        if(typeof(this.matchdata.liveData.matchDetails.scores)  !== 'undefined'){
          if(typeof(this.matchdata.liveData.matchDetails.scores.pen) != "undefined" && this.matchdata.liveData.matchDetails.scores.pen !== null) {
            if(this.matchdata.liveData.matchDetails.scores.pen.home > this.matchdata.liveData.matchDetails.scores.pen.away) {
              return "winning-team";
            } else if(this.matchdata.liveData.matchDetails.scores.pen.home < this.matchdata.liveData.matchDetails.scores.pen.away) {
              return "losing-team";
            }
          }

          if(this.matchdata.liveData.matchDetails.scores.ft.home > this.matchdata.liveData.matchDetails.scores.ft.away) {
            return "winning-team";
          } else if(this.matchdata.liveData.matchDetails.scores.ft.home < this.matchdata.liveData.matchDetails.scores.ft.away) {
            return "losing-team";
          }
        }
      } else if(typeof(this.matchdata.liveData) !== 'undefined' && this.type == "second"){
        if(typeof(this.matchdata.liveData.matchDetails.scores)  !== 'undefined'){
          if(typeof(this.matchdata.liveData.matchDetails.scores.pen) != "undefined" && this.matchdata.liveData.matchDetails.scores.pen !== null) {
            if(this.matchdata.liveData.matchDetails.scores.pen.home < this.matchdata.liveData.matchDetails.scores.pen.away) {
              return "winning-team";
            }

            if(this.matchdata.liveData.matchDetails.scores.pen.home > this.matchdata.liveData.matchDetails.scores.pen.away) {
              return "losing-team";
            }
          }

          if(this.matchdata.liveData.matchDetails.scores.ft.home < this.matchdata.liveData.matchDetails.scores.ft.away) {
            return "winning-team";
          } else if(this.matchdata.liveData.matchDetails.scores.ft.home > this.matchdata.liveData.matchDetails.scores.ft.away) {
            return "losing-team";
          }
        }
      }
    }
      return ""; 
  }
  
}
